import { theplant } from "../proto";
import { CHECKOUT_COMPLETE_PAYMENT_PATH } from "../constants/Paths";
import { pick } from "../js/shared/utils";
import { env } from "../config";

type T3DSAuthInformation = theplant.ec.service.orders.IThreeDSResult;

type TPaymentType = theplant.ec.service.orders.PaymentType;
const PaymentType = theplant.ec.service.orders.PaymentType;

export function threeDSArgument(paymentType?: TPaymentType | null) {
  const disable3DS = env.CREDIT_CARD_3DS_DISABLE === "true";

  if (paymentType !== PaymentType.CREDIT_CARD || disable3DS) return {};

  return {
    threeDSTermUrl: `${window.origin}${CHECKOUT_COMPLETE_PAYMENT_PATH}?payment_type=${paymentType}`,
  };
}

const threeDSInfoKeys: (keyof T3DSAuthInformation)[] = [
  "acqId",
  "acqName",
  "attemptKbn",
  "authId",
  "cardBrand",
  "fingerprint",
  "hc",
  "issurClass",
  "issurId",
  "issurName",
  "requestorErrorCode",
  "result",
  "serverErrorCode",
];

export function threeDSAuthInformation() {
  const queryParam = getThreeDSInformationFromSearch();
  if (queryParam.paymentType !== String(PaymentType.CREDIT_CARD)) return {};

  const threeDSInformation: T3DSAuthInformation = pick(
    queryParam,
    threeDSInfoKeys
  );
  return {
    threeDSResult: threeDSInformation,
    orderCode: queryParam.orderCode,
  };
}

/* 
Since go's field names cannot start with numbers, some fields need to be mapped here.
*/
type StringMap = Record<string, string>;
const SPECIAL_KEY_MAP: StringMap = {
  "3ds_auth_id": "authId",
  "3dsecure_requestor_error_code": "requestorErrorCode",
  "3dsecure_server_error_code": "serverErrorCode",
};

export function getThreeDSInformationFromSearch(
  search = window.location.search
) {
  const searchParams = new URLSearchParams(search);
  const params: StringMap = {};
  for (const [key, value] of searchParams.entries()) {
    // snake To camel: order_code => orderCode
    const camelKey =
      SPECIAL_KEY_MAP[key] ||
      key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

    params[camelKey] = value;
  }

  return params;
}

export const SERVER_3DS_ERROR_MAP: StringMap = {
  "3DS_API_ERROR":
    "現在サービスがご利用頂けません。しばらくしてから、もう一度ご利用お試しください。",
  INVALID_TERM_URL: "入力内容をご確認ください。",
  INVALID_3DS_RESULT:
    "このアカウントは現在ご利用いただけません。カスタマーサポートにお問い合わせください。",
  "3DS_AUTH_FAILED": "入力されたカード情報での決済が拒否されました。",
};
